import { EnumCommodity } from '../../api'
import {
  CommodityFilterModel,
  CustomFilterModel,
  DataTableFilter,
  DateFilterModel
} from '../store.model'

export enum PagesStateActionTypes {
  STORE_DATATABLE_FILTER = 'STORE_DATATABLE_FILTER',
  STORE_DATATABLE_SEARCH = 'STORE_DATATABLE_SEARCH',
  STORE_DATATABLE_ROWS_PER_PAGE = 'STORE_DATATABLE_ROWS_PER_PAGE',
  STORE_DATE_FILTER = 'STORE_DATE_FILTER',
  STORE_CUSTOM_FILTER = 'STORE_CUSTOM_FILTER',
  STORE_ACTIVE_TAB = 'STORE_ACTIVE_TAB',
  STORE_ACTIVE_TAB_POWER = 'STORE_ACTIVE_TAB_POWER',
  STORE_COMMODITY_FILTER = 'STORE_COMMODITY_FILTER',
  STORE_ACTIVES_FILTER = 'STORE_ACTIVES_FILTER'
}

export interface StoreDataTableFilterAction {
  type: PagesStateActionTypes
  payload: { page: string; filter: DataTableFilter }
}

export interface StoreDataTableSearchAction {
  type: PagesStateActionTypes
  payload: { page: string; search: string }
}

export interface StoreDataTableRowsPerPageAction {
  type: PagesStateActionTypes
  payload: { page: string; rowsPerPage: number }
}

export interface StoreDateFilterAction {
  type: PagesStateActionTypes
  payload: { page: string; filter: DateFilterModel }
}

export interface StoreCustomFilterAction {
  type: PagesStateActionTypes
  payload: { page: string; filter: CustomFilterModel }
}

export interface StoreActiveTabAction {
  type: PagesStateActionTypes
  payload: { page: string; tab: number }
}

export interface StoreCommodityFilterAction {
  type: PagesStateActionTypes
  payload: { page: string; filter: EnumCommodity }
}

export interface StoreShowOnlyActivesFilterAction {
  type: PagesStateActionTypes
  payload: { page: string; isActive: boolean }
}

export const storeDataTableFilterAction = (
  page: string,
  filter: DataTableFilter
): StoreDataTableFilterAction => {
  return {
    type: PagesStateActionTypes.STORE_DATATABLE_FILTER,
    payload: { page: page, filter: filter }
  }
}

export const storeDataTableRowsPerPageAction = (
  page: string,
  rowsPerPage: number
): StoreDataTableRowsPerPageAction => {
  return {
    type: PagesStateActionTypes.STORE_DATATABLE_ROWS_PER_PAGE,
    payload: { page: page, rowsPerPage: rowsPerPage }
  }
}

export const storeDataTableSearchAction = (
  page: string,
  search: string
): StoreDataTableSearchAction => {
  return {
    type: PagesStateActionTypes.STORE_DATATABLE_SEARCH,
    payload: { page: page, search: search }
  }
}

export const storeDateFilterAction = (
  page: string,
  filter: DateFilterModel
): StoreDateFilterAction => {
  return {
    type: PagesStateActionTypes.STORE_DATE_FILTER,
    payload: { page: page, filter: filter }
  }
}

export const storeCustomFilterAction = (
  page: string,
  filter: CustomFilterModel
): StoreCustomFilterAction => {
  return {
    type: PagesStateActionTypes.STORE_CUSTOM_FILTER,
    payload: { page: page, filter: filter }
  }
}

export const storeActiveTabAction = (page: string, tab: number): StoreActiveTabAction => {
  return {
    type: PagesStateActionTypes.STORE_ACTIVE_TAB,
    payload: { page: page, tab: tab }
  }
}

export const storeActiveTabPowerAction = (page: string, tab: number): StoreActiveTabAction => {
  return {
    type: PagesStateActionTypes.STORE_ACTIVE_TAB_POWER,
    payload: { page: page, tab: tab }
  }
}

export const storeCommodityFilterAction = (
  page: string,
  filter: CommodityFilterModel
): StoreCommodityFilterAction => {
  return {
    type: PagesStateActionTypes.STORE_COMMODITY_FILTER,
    payload: { page: page, filter: filter }
  }
}

export const storeShowOnlyActivesFilterAction = (
  page: string,
  showOnlyActives: boolean
): StoreShowOnlyActivesFilterAction => {
  return {
    type: PagesStateActionTypes.STORE_ACTIVES_FILTER,
    payload: { page, isActive: showOnlyActives }
  }
}
